import $fJU0O$axios from "axios";
import $fJU0O$md5 from "md5";
import {UAParser as $fJU0O$UAParser} from "ua-parser-js";
import {datadogRum as $fJU0O$datadogRum} from "@datadog/browser-rum";
import {useState as $fJU0O$useState, useEffect as $fJU0O$useEffect} from "react";
import {useViewport as $fJU0O$useViewport} from "@lamimed/pantheon";

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}



async function $8bc5d05bd949b2a3$export$f3408acaf769e867(storageKey = "fingerprint") {
    var _result_device, _result_device1;
    const response = await (0, $fJU0O$axios).get("https://api.bigdatacloud.net/data/client-ip");
    const ipAddress = response === null || response === void 0 ? void 0 : response.data.ipString;
    const parser = new (0, $fJU0O$UAParser)(window.navigator.userAgent);
    const result = parser.getResult();
    const deviceIdentifier = `${result === null || result === void 0 ? void 0 : (_result_device = result.device) === null || _result_device === void 0 ? void 0 : _result_device.vendor}-${result === null || result === void 0 ? void 0 : (_result_device1 = result.device) === null || _result_device1 === void 0 ? void 0 : _result_device1.model}-${result.os.name}`;
    const fingerprintString = `${ipAddress}-${deviceIdentifier}`;
    const hash = (0, $fJU0O$md5)(fingerprintString);
    localStorage.setItem(storageKey, hash);
    return hash;
}


const $5be6988c6890a356$export$3da3d26c2248d2de = (error)=>{
    /* NOTE: this workaround is only required until the next axios release and we will be able
  to pass the error type into isAxiosError
  related issue: https://github.com/axios/axios/pull/4344 */ return error;
};





const $1c8c1150afa34e7d$export$b1d208d87ef266d6 = ({ error: error , where: where , context: context , showErrorObj: showErrorObj  })=>{
    if ((0, $fJU0O$axios).isAxiosError(error) && error.code != "ERR_NETWORK") {
        var _getAxiosError_response;
        (0, $fJU0O$datadogRum).addError(error, {
            where: where,
            context: context,
            error: {
                message: (_getAxiosError_response = (0, $5be6988c6890a356$export$3da3d26c2248d2de)(error).response) === null || _getAxiosError_response === void 0 ? void 0 : _getAxiosError_response.data.message,
                description: showErrorObj !== null && showErrorObj !== void 0 ? showErrorObj : error
            }
        });
        return;
    }
    const err = error;
    (0, $fJU0O$datadogRum).addError(err, {
        where: where,
        context: context,
        error: {
            message: err.message,
            description: showErrorObj !== null && showErrorObj !== void 0 ? showErrorObj : err
        }
    });
};



function $5c9ac8b5c86f1b08$export$83cd1f1503eb19c0(token) {
    try {
        if (!token) return null;
        const base64URL = token.split(".")[1];
        const base64 = base64URL.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(""));
        return JSON.parse(jsonPayload);
    } catch (error) {
        (0, $1c8c1150afa34e7d$export$b1d208d87ef266d6)({
            error: error,
            where: "parseJwt",
            context: token
        });
        return null;
    }
}


var $415dafb2b476c859$exports = {};
var $b88ba9baae70dbaf$exports = {};

$parcel$export($b88ba9baae70dbaf$exports, "useRemoveBodyScroll", () => $b88ba9baae70dbaf$export$370d6ca9386b7540);


const $b88ba9baae70dbaf$export$370d6ca9386b7540 = (removeScroll, options)=>{
    const [isBodyScrolling, setIsBodyScrolling] = (0, $fJU0O$useState)();
    const { greaterThan: greaterThan  } = (0, $fJU0O$useViewport)();
    const showScroll = ()=>{
        setIsBodyScrolling(true);
        document.body.style.overflowY = "auto";
    };
    const hideScroll = ()=>{
        document.body.style.overflowY = "hidden";
        setIsBodyScrolling(false);
    };
    (0, $fJU0O$useEffect)(()=>{
        if (greaterThan("tablet") && (options === null || options === void 0 ? void 0 : options.onlyDesktop)) return;
        if (removeScroll) {
            hideScroll();
            return;
        }
        showScroll();
    }, [
        removeScroll,
        greaterThan,
        options === null || options === void 0 ? void 0 : options.onlyDesktop
    ]);
    return {
        isBodyScrolling: isBodyScrolling,
        showScroll: showScroll,
        hideScroll: hideScroll
    };
};


var $b2b961a112e009a7$exports = {};

$parcel$export($b2b961a112e009a7$exports, "useStorage", () => $b2b961a112e009a7$export$95809329f49ea9f9);
const $b2b961a112e009a7$export$95809329f49ea9f9 = ()=>{
    const set = (key, value)=>{
        if (typeof window !== "undefined") localStorage.setItem(key, JSON.stringify(value));
    };
    const get = (key)=>{
        if (typeof window !== "undefined") return localStorage.getItem(key);
        return JSON.stringify("");
    };
    const remove = (key)=>{
        if (typeof window !== "undefined") return localStorage.removeItem(key);
    };
    return {
        set: set,
        get: get,
        remove: remove
    };
};


$parcel$exportWildcard($415dafb2b476c859$exports, $b88ba9baae70dbaf$exports);
$parcel$exportWildcard($415dafb2b476c859$exports, $b2b961a112e009a7$exports);




export {$8bc5d05bd949b2a3$export$f3408acaf769e867 as generateFingerprint, $5be6988c6890a356$export$3da3d26c2248d2de as getAxiosError, $1c8c1150afa34e7d$export$b1d208d87ef266d6 as sendToErrorTracking, $5c9ac8b5c86f1b08$export$83cd1f1503eb19c0 as parseJwt, $b88ba9baae70dbaf$export$370d6ca9386b7540 as useRemoveBodyScroll, $b2b961a112e009a7$export$95809329f49ea9f9 as useStorage};
//# sourceMappingURL=index.esm.js.map
